namespace RecordShield.Workspace {
    export interface SerialKeyDetailsListRequest extends Serenity.ListRequest {
        SerachText?: string;
    }
}
